import { combineReducers } from 'redux';
import { OPEN_CONFIRM_MODAL, CLOSE_CONFIRM_MODAL } from './constants';
import valueReducer from '../reducers/valueReducer';
import booleanReducer from '../reducers/booleanReducer';

const opened = booleanReducer(false, [OPEN_CONFIRM_MODAL], [CLOSE_CONFIRM_MODAL]);
const settings = valueReducer({}, OPEN_CONFIRM_MODAL, CLOSE_CONFIRM_MODAL);

const reducer = combineReducers({
  opened,
  settings,
});

export default reducer;
